import React from "react"
import { AppAcrissAutocomplete } from "@components"

import { useAcrissGroups, useAcrissGroupsValidator } from "Pages/User/Settings/AcrissGroupTab/@hooks"
import { acrissGroupFormData } from "Pages/User/Settings/AcrissGroupTab/@signals"


export default function AcrissGroupDrawerAcriss() {
	const { handleChangeFormData } = useAcrissGroups()
	const { acrissError } = useAcrissGroupsValidator()

	return <AppAcrissAutocomplete
		placeholder="Select acriss codes"
		error={acrissError}
		value={acrissGroupFormData.value?.acriss || []}
		onChange={e => handleChangeFormData(e.target.value, 'acriss')}
	/>
}
